var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Tooltip,{attrs:{"label":_setup.title,"position":"is-bottom","size":"is-large","multilined":true}},[_c(_setup.PageSubtitle,{attrs:{"text":_setup.title}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }